<template>
  <!-- 订舱 -->
    <div class="Booking">
      <TopNavigation  class="topNavigation"></TopNavigation>
      <div class="typeArea">
         <!-- 面包屑 -->
         <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>船东SPOT</el-breadcrumb-item>
            <el-breadcrumb-item>查询结果</el-breadcrumb-item>
            <el-breadcrumb-item class="bread">订舱</el-breadcrumb-item>
          </el-breadcrumb>

          <!-- 订舱信息 -->
          <div class="info">
            <div class="shang">
              <div class="logo">
                <img :src="shipownerLogo" alt="">
            </div>
            <div class="qiyun">
                <div class="date"><span class="jiacu">ETD:</span>{{ parameter.etd || '--' }}</div>
                <div class="address">{{ parameter.qygName }}</div>
            </div>
            <div class="dao">
                <div class="tian">{{ parameter.shipping_date }}天</div>
                <img src="@/assets/images/Group 113@2x.png" alt="">
                <div class="zhida">{{ parameter.zhongzhuan==0?'中转':'直达'}}</div>
            </div>
            <div class="qiyun">
                <div class="date"><span class="jiacu">ETA:</span>{{ parameter.eta || '--' }}</div>
                <div class="address">{{ parameter.mdgName }}</div>
            </div>
            </div>
              <div class="zhong">
                <div>船名航次：{{parameter.vessel}} / {{parameter.voyage}}</div>
                <div class="kuan">
                    运输条款：{{parameter.transClause}}
                </div>
                <div class="kuan">
                  航线代码：TP8aaa
                </div>
            </div>
            <div class="xia">
              <div>
                  运价有效期：{{parameter.expireStart}} - {{parameter.expireEnd}}
              </div>
            </div>
          </div>
          <!-- 箱型 -->
          <div class="boxType">
            <div class="title">
              选择箱型箱量
            </div>
            <div class="boxNum">
              <div 
              class="box-yi"
              v-for="(item,index) in form.basePriceList"
              :key="index">
                <div class="box-tit">
                  <span>*</span>{{item.ctnType}}
                </div>
                <!-- <el-input-number @change="(currentValue) => changeBase(currentValue, item)" v-model="item.number"></el-input-number> -->
                <el-input-number :disabled="item.basePrice==0" :min="0" @change="changeBase" v-model="item.number"></el-input-number>
                <div class="qian">
                  <div>单价：${{item.totalPrice}}</div>
                  <div>保证金：￥{{ spot_dead_freight[item.ctnType] || '--' }}</div>
                </div>
              </div>
            </div>
            
          </div>

          <div class="account">
            <div class="title">
              订舱账号
            </div>
            <div class="account-conm">
              <div class="conm-con">船司账号</div>
              <el-select clearable v-model="shipID" @change="changeShip" placeholder="选择自有船公司账号">
                <el-option
                  v-for="item in shipList"
                  :key="item.id"
                  :label="item.carrier_code"
                  :value="item.id">
                </el-option>
              </el-select>
              <div class="disan">
                <div>没有船司账号，使用第三方账号(需缴纳保证金)</div>
                <!-- <el-radio v-model="radioD"></el-radio> -->
                <div v-if="form.booking_account==1" @click="form.booking_account=2" class="yuan"></div>
                <img v-if="form.booking_account==2" @click="form.booking_account=1" class="yuan_dui" src="@/assets/images/Group 177@2x.png" alt="">
              </div>
              <div class="xian"></div>
              <div class="feiyong">
                <div>
                  <i class="el-icon-info"></i>
                  服务费：<span>¥{{platform_service_fee}}</span>
                </div>
                <div>
                  <i class="el-icon-info"></i>
                  保证金：<span>¥{{spot_dead_freightTotal}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 没有账号  填写信息 -->
          <!-- 货物信息 -->
          <div  v-if="form.booking_account==2" class="CargoInformation">
            <div class="title">货物信息</div>

            <div class="info-shang">
              <div>
                <div class="word"><span>*</span>包装单位</div>
                <el-select v-model="form.packing_unit" placeholder="请选择">
                  <el-option
                    v-for="item in packingList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div>
                <div class="word"><span>*</span>件数</div>
                <el-input
                  min='0' type="number"
                  @blur="onBlur"
                  v-model="form.quantity"
                  placeholder="请输入内容"
                ></el-input>
              </div>
              <div>
                <div class="word"><span>*</span>总货重(kg)</div>
                <el-input
                  min='0' type="number"
                  @blur="onBlur"
                  v-model="form.totle_weight"
                  placeholder="请输入内容"
                ></el-input>
              </div>
              <div>
                <div class="word"><span>*</span>体积(cbm)</div>
                <el-input
                  min='0' type="number"
                  @blur="onBlur"
                  v-model="form.totle_volume"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>

            <div class="info-shang">
              <div>
                <div class="word"><span>*</span>唛头</div>
                <el-input
                  type="textarea"
                  v-model="form.shipping_mark"
                  placeholder="请输入内容"
                ></el-input>
              </div>
              <div>
                <div class="word"><span>*</span>货物描述</div>
                <el-input
                  type="textarea"
                  v-model="form.describe"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>
          </div>
          <!-- 订舱联系人 -->
          <div  v-if="form.booking_account==2" class="CargoInformation phone-info">
            <div class="title">订舱联系人</div>

            <div class="info-shang">
              <div class="yi1">
                <div class="word"><span>*</span>订舱联系人</div>
                <el-input v-model="form.linkman" placeholder="请输入"></el-input>
              </div>
              <div class="yi1">
                <div class="word"><span>*</span>联系人电话</div>
                <el-input
                  @blur="validDianhua"
                  v-model="form.linkman_phone"
                  placeholder="请输入内容"
                ></el-input>
              </div>
              <div
                class="yi"
                v-for="(item, index) in emailList"
                :key="index"
                :class="(index + 3) % 4 == 0 ? 'yi2' : 'yi'"
              >
                <div class="word"><span>*</span>联系人邮箱</div>
                <div class="ipt_del">
                  <el-input @blur="validEmsil" v-model="item.email" placeholder="请输入"></el-input>
                  <div @click="removeEmail(index)" class="delete">删除</div>
                </div>
              </div>
            </div>

            <div class="add" @click="addEmail">
              <i class="el-icon-circle-plus-outline"></i>
              <div>新增联系人邮箱</div>
            </div>
            

            <div class="info-shang info_phone">
              <div class="title">订单备注</div>
              <div>
                <div class="word">备注信息</div>
                <el-input
                  type="textarea"
                  v-model="form.order_remarks"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </div>
          </div>

          

          <div class="fujia">
            <div class="title">
              附加费
            </div>
            
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>费用类型</td>
              <td colspan="2">费用内容</td>
            </tr>
            <tr class="tbody" v-for="(item,index) in priceList" :key="index">
              <td  class="first">{{item.feeName}}</td>
              <td>{{item.type == 1 ? '按柜收取' : '按票收取' }}</td>
              <!-- <td>{{item.fee}}</td> -->
              <td  colspan="2" v-if="item.type == 0">CNY {{item.fee}}</td>
              <td class="xiaotab" v-if="item.type == 1">

                <!-- {{item.fee}} -->
                <table  class="table">
                  <tr  class="theader">
                    <td v-for="(value,key,ind) in item.fee" :key="ind">{{key}}</td>
                    <!-- <td>CNY {{value}}</td> -->
                  </tr>
                  <tr  class="tbody" >
                    <!-- <td>{{key}}</td> -->
                    <td v-for="(value,key,ind) in item.fee" :key="ind">CNY {{value}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

            <!-- <div class="title dd">
              D&D
            </div>
            <div>
              <div class="pdf_tit">起运港Demurrage and detention</div>
              <div class="pdf">
                <div class="pdf-t">PDF</div>
                <div class="pdf-click">点击查看文件内容</div>
              </div>
            </div>
            <div>
              <div class="pdf_tit">目的港Demurrage and detention</div>
              <div class="pdf">
                <div class="pdf-t">PDF</div>
                <div class="pdf-click">点击查看文件内容</div>
              </div>
            </div> -->
          </div>
      </div>
      <div class="fukuan">
        <div class="fk-content typeArea">
          <div class="fk-left">
            <div class="er">
              提交本页订舱信息即代表您同意<span   @click="xieyi">《服务协议》</span>相关条款进行订舱
            </div>
            <div class="san">
              提交订舱后将从余额内冻结亏仓费
            </div>
          </div>
          <div class="fk-right">
            <span class="zong"> CNY {{platform_service_fee + spot_dead_freightTotal }} + USD {{ totalCost }}</span>
            <el-button @click="table = true" class="mingxi">价格明细</el-button>
            <el-button class="tijiao" @click="submitDingcang">提交订舱</el-button>
          </div>
        </div>
      </div>
      <Bottom />
      <!-- 价格明细抽屉 -->
      <!--  -->
      <el-drawer
        title="价格明细"
        :visible.sync="table"
        direction="rtl"
        :with-header="false"
        size="50%">
        <div class="drawer-title">
          <div class="word">
            价格明细<span>实际费用以账单为准</span>
          </div>
          <div>
            <i @click="table = false" class="el-icon-close"></i>
          </div>
        </div>
        <div class="tab-det">
          <div class="tab-tit">基本海运费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>箱型</td>
              <td>价格</td>
            </tr>
            <tr class="tbody"  v-for="(item,ind) in basicList" :key="ind">
              <td  class="first">基本海运费</td>
              <td>{{item.ctnType}}</td>
              <td>{{item.currency}} {{item.totalPrice}}</td>
            </tr>
          </table>

          <!-- <div class="tab-tit">人民币港杂费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>费用类型</td>
              <td colspan="2">费用内容</td>
            </tr>
            <tr class="tbody" v-for="(item,index) in priceList" :key="index">
              <td  class="first">{{item.feeName}}</td>
              <td>{{item.type == 1 ? '按柜收取' : '按票收取' }}</td>
              <td  colspan="2" v-if="item.type == 0">CNY {{item.fee}}</td>
              <td class="xiaotab" v-if="item.type == 1">

                <table  class="table">
                  <tr  class="theader">
                    <td v-for="(value,key,ind) in item.fee" :key="ind">{{key}}</td>
                  </tr>
                  <tr  class="tbody" >
                    <td v-for="(value,key,ind) in item.fee" :key="ind">CNY {{value}}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table> -->
        </div>
        <!-- <div class="tab-det">
          <div class="tab-tit">基本海运费</div>
          <table class="table">
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>20GP</td>
              <td>40GP</td>
              <td>40HQ</td>
              <td>单位</td>
            </tr>
            <tr 
            v-for="(item,index) in 3"
            :key="index" 
            class="tbody">
              <td class="first">海运附加费</td>
              <td>USD 2,564.00</td>
              <td>USD 2866.00</td>
              <td>USD 2866.00</td>
              <td>箱</td>
            </tr>
          </table>
        </div>
        <div class="tab-det">
          <div class="tab-tit">起运港费用</div>
          <table class="table">
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>20GP</td>
              <td>40GP</td>
              <td>40HQ</td>
              <td>单位</td>
            </tr>
            <tr 
            v-for="(item,index) in 3"
            :key="index" 
            class="tbody">
              <td class="first">海运附加费</td>
              <td>USD 2,564.00</td>
              <td>USD 2866.00</td>
              <td>USD 2866.00</td>
              <td>箱</td>
            </tr>
          </table>
        </div> -->
        <div class="drawer__footer">
          <el-button class="quxiao" @click="table = false">取 消</el-button>
          <el-button class="dingcanggg" @click="table = false">去订舱</el-button>
        </div>
      </el-drawer>

      <!-- 协议 -->
      <el-dialog
        :title="ratetitle"
        :visible.sync="dialogVisiblexieyi"
        width="30%">
        <!-- <span>{{ratetext}}</span> -->
        <div v-html="ratetext"></div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisiblexieyi = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisiblexieyi = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
   
<script>
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
import { indexPolicy,shippingAccountList,dict,shippingAccountDetail,spotOrder,config } from "@/api/api";
export default {
  components:{
      Bottom,
      TopNavigation,
  },
  data() {
    return {
      num:0,
      emailList:[
        {email:''}
      ],
      // 上传文件列表
      fileList: [],
      // 付款方式  预付到付
      radio:'1',
      radioD:'',

      // 价格明细抽屉是否打开
      table: false,
     
      parameter:{},
      headers:{
          'token':localStorage.getItem('token')
      },
      form:{
        pol_code:'', // 起运港代码
        pod_code:'', // 目的港代码
        carrier_code:'', // 船公司代码
        is_transit:'', // 中转/直达：0直达、1中转
        etd:'', // 计划离港时间
        eta:'', // 计划到港时间
        shipping_date:'', // 航程天数
        transportation_terms:'', // 运输条款，如：CY-CY
        vessel:'', // 船名
        voyage:'', // 航次
        freight_rate_state_time:'', // 运价有效期，开始时间
        freight_rate_end_time:'', // 运价有效期，结束时间
        packing_unit:'', // 包装单位
        quantity:'', // 件数
        totle_weight:'', // 总货重（kgs）
        totle_volume:'', // 体积（cbm）
        describe:'', // 货物描述
        shipping_mark:'', // 唛头
        linkman:'', // 订舱联系人
        linkman_phone:'', // 订舱联系人电话
        booking_account:1, // 订舱账号：1自有账号、2第三方账号
        enterprise_name:'', // 自有账号企业名称
        account:'', // 自有账号账号
        password:'', // 自有账号密码
        service_charge:'', // 订单服务费
        dead_freight:'', // 订单亏舱费总金额
        order_remarks:'', // 订单备注
        basePriceList:[], // 箱型箱量，如：[{"ctnType":"箱型","basePrice":"基础海运费","totalPrice":"海运总费用（含基础海运费+附加费）","currency":"货币单位","number":"数量"}]
        transitPort:[], // 中转数据，如：[{"pod":"中转港名称","podCode":"中转五字码","wharf":"中转港码头"}]
        surcharge:[], // 海运附加费，如：[{"feeName":"费用名称","type":"费用类型：1：按柜收取 0：按票收取","fee":"费用内容：type=1时为对象"}]
        email:[], // 订舱联系人邮箱，如：["邮箱一","邮箱二"]
      },
      shipID:'',
      // 船司账号列表
      shipList:[],
      // 包装单位列表
      packingList: [],
      rowList: [],
      rowListpos: 0,
      priceList:[],
      basicList:[],
      // priceList:[ { "mingzi": "20gp", "neirong": "30" }, { "mingzi": "40gp", "neirong": "30" }, { "mingzi": "40hq", "neirong": "30" }, { "mingzi": "45hq", "neirong": "30" }, { "mingzi": "20rf", "neirong": "30" }, { "mingzi": "40rh", "neirong": "30" }, { "mingzi": "20ot", "neirong": "30" }, { "mingzi": "40ot", "neirong": "30" } ]
      // 总费用
      totalCost:0,
      shipownerLogo:'',
      // 保证金
      platform_service_fee:0,
      spot_dead_freight:0,
      spot_dead_freightTotal:0,
      platformTotal: 0,
      dialogVisiblexieyi:false,
      ratetitle:'',
      ratetext:'',
    }
  },
  methods: {
    
    // 富文本处理
    showHtml(str) {
      return str
        .replace(str ? /&(?!#?\w+;)/g : /&/g, "&amp;")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&amp;nbsp;/g, "\u3000");
    },
    // 《会员服务协议》
    async getindexPolicy(){
      try {
        const res = await indexPolicy({type:'service'});
        // const res = await axios.get('https://serve.dhcang.com/api/index/policy?type=service')
        this.ratetitle = this.showHtml(res.data.title);
        this.ratetext = this.showHtml(res.data.content);
      } catch (error) {
        console.log(error, "获取平台协议失败");
      }
    },
    xieyi(){
      this.dialogVisiblexieyi = true
      this.getindexPolicy()
    },
    addEmail() {
      this.emailList.push({ email: ''}); // 添加新行
    },
    removeEmail(index) {
      if(this.emailList.length==1){
        this.$message({
          type:'error',
          message:'最少要填写一个'
        })
      }else{
        this.emailList.splice(index, 1); // 删除指定行
      }
    },
    // 文件上传
    // handleRemove(ind) {
    //   console.log(ind);
    //   this.fileList.splice(ind,1)
    // },
    // handlePreview(file) {
    //   console.log(file);
    // },
    // handleExceed(files, fileList) {
    //   this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    // },
    // beforeRemove(file, fileList) {
    //   console.log(fileList);
    //   return this.$confirm(`确定移除 ${ file.name }？`);
    // },
    async getShipList(){
      try {
            const res = await shippingAccountList({
              page_no:1,
              page_size:10,
              is_disable:0,
            },this.headers)
            this.shipList=res.data.lists
        } catch (error) {
            console.log(error,'失败');
        }
    },
    // 获取包装单位
    async getPacking() {
      try {
        const res = await dict(
          {
            type: "packing_unit",
          },
          this.headers
        );
        if (res.code == 1) {
          this.packingList = res.data.packing_unit;
        }
      } catch (error) {
        console.log(error, "失败");
      }
    },
    // 订舱
    async submitDingcang(){
      // this.$router.push('/ShipSPOTOrderDetails')

      this.form.pol_code = this.parameter.polCd
      this.form.pod_code = this.parameter.podCd
      this.form.carrier_code = this.parameter.carrierCd
      this.form.is_transit = this.parameter.transitPort.length>0 ? 0 : 1
      this.form.etd = this.parameter.etd
      this.form.eta = this.parameter.etd
      this.form.shipping_date = this.parameter.shipping_date
      this.form.vessel = this.parameter.vessel
      this.form.voyage = this.parameter.voyage
      this.form.freight_rate_state_time = this.parameter.expireStart
      this.form.freight_rate_end_time = this.parameter.expireEnd
      this.form.transitPort = this.parameter.transitPort
      this.form.transportation_terms = this.parameter.transClause

      // this.form.service_charge = this.platform_service_fee
      // this.form.dead_freight = this.spot_dead_freight

      this.form.service_charge = this.platform_service_fee  // 订单服务费  // 平台服务费
      this.form.dead_freight = this.spot_dead_freightTotal  // 订单保证金总金额  箱量*保证金  //spot保证金

      this.form.surcharge = JSON.parse(sessionStorage.getItem('parameter')).localChargeList

      this.form.email = [];
      for (let i = 0; i < this.emailList.length; i++) {
        this.form.email.push(this.emailList[i].email);
      }

      if(this.form.booking_account==1){
        this.form.packing_unit='' // 包装单位
        this.form.quantity='' // 件数
        this.form.totle_weight='' // 总货重（kgs）
        this.form.totle_volume='' // 体积（cbm）
        this.form.describe='' // 货物描述
        this.form.shipping_mark='' // 唛头
        this.form.linkman='' // 订舱联系人
        this.form.linkman_phone='' // 订舱联系人电话
      }else{
        this.form.enterprise_name='' // 自有账号企业名称
        this.form.account='' // 自有账号账号
        this.form.password='' // 自有账号密码
      }

      // 当前运费不是实时运费，以订舱为准
      this.$confirm('当前运费不是实时运费，请以订舱为准', '提示', {confirmButtonText: '提交',cancelButtonText: '取消',type: 'warning'}).then(async() => {
        try {
          const res = await spotOrder(this.form,this.headers)
          if(res.code==1){
            this.$message({
              type:'success',
              message:"提交成功"
            })
            sessionStorage.removeItem('parameter')
            this.$router.push({
              path:'/Order',
            })
          }else{
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        } catch (error) {
          console.log(error,'失败');
        }
      }).catch(() => {
          this.$message({
              type: 'info',
              message: '已取消'
          });
      }); 
    },
    // 获取船司账号详情
    async changeShip(){
      const res = await shippingAccountDetail({id:this.shipID},this.headers)
      if(res.code==1){
        this.form.carrier_code=res.data.carrier_code
        this.form.enterprise_name=res.data.enterprise_name
        this.form.password=res.data.password
        this.form.account=res.data.account
      }
    },
    // 获取总费用
    changeBase(){
      // this.totalCost = this.totalCost + (Number(row.totalPrice) * currentValue)
      // console.log(11111,'feiy',currentValue,row);
      // this.platformTotal = this.platformTotal + currentValue
      this.totalCost = 0
      this.platformTotal = 0
      this.spot_dead_freightTotal=0
      let qian = 0
      for (let i = 0; i < this.form.basePriceList.length; i++) {
        this.totalCost += this.form.basePriceList[i].totalPrice * this.form.basePriceList[i].number
        this.platformTotal += this.form.basePriceList[i].number

        if(this.spot_dead_freight[this.form.basePriceList[i].ctnType]>0 && this.spot_dead_freight[this.form.basePriceList[i].ctnType] != undefined){
          qian = this.spot_dead_freight[this.form.basePriceList[i].ctnType]
        }else{
          qian = 0
        }
        this.spot_dead_freightTotal += this.form.basePriceList[i].number * qian
      }
    },
    async getconfig(){
      try {
        const res = await config(this.headers)
         this.platform_service_fee = res.data.platform_service_fee
         this.spot_dead_freight = res.data.spot_dead_freight
      } catch (error) {
        console.log(error,'失败');
      }
    },
     // 校验邮箱
     validEmsil(e) {
      let emial = e.target.value
      if(emial==''){
        return
      }
      if (emial == "" || emial == undefined) {
        this.$message({
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          emial
        )
      ) {
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 校验手机号
    validDianhua() {
      let dianhua = this.form.linkman_phone
      if(dianhua==''){
        return
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 输入的数字大于0
    onBlur(e){
     if(e.target.value == ''){
        return
      }
      if(!/\d$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为数字'
        })
      }
    },
  },
  mounted(){
    this.parameter = JSON.parse(sessionStorage.getItem('parameter'))
    this.shipownerLogo = this.parameter.shipowner.logo
    this.priceList=[]
    for (let i = 0; i < this.parameter.localChargeList.length; i++) {
      if(this.parameter.localChargeList[i].type==1){
        this.parameter.localChargeList[i].fee = JSON.parse(JSON.stringify(this.parameter.localChargeList[i].fee))
      }
    }
    this.priceList = this.parameter.localChargeList
    this.basicList = this.parameter.basePriceList
    
    this.parameter.zhongzhuan = this.parameter.transitPort.length>0 ? 0 : 1
    // for (let i = 0; i < this.priceList.length; i++) {
    //   if(this.priceList[i].type==1){
    //     this.priceList[i].fee = Object.entries(this.priceList[i].fee).map(([key, value]) => ({
    //         mingzi: key,
    //         neirong: value
    //     }))
    //   }
    // }
   
    // console.log(11111,'camsh',this.parameter.basePriceList.length);
    // for (let i = 0; i < this.parameter.basePriceList.length; i++) {
    //   this.parameter.basePriceList[i].number=0
    // }


    this.form.basePriceList = []

    for (let i = 0; i < this.parameter.basePriceList.length; i++) {
      this.form.basePriceList.push({
        ctnType:this.parameter.basePriceList[i].ctnType,
        basePrice:this.parameter.basePriceList[i].basePrice,
        totalPrice:this.parameter.basePriceList[i].totalPrice,
        currency:this.parameter.basePriceList[i].currency,
        number:0,
      })
    }

    this.getShipList()
    this.getPacking()
    this.getconfig()
  },
  watch:{

  }
}
</script>

<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}


.el-breadcrumb{
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link{
      color: pink;
  }
}

:deep(.el-breadcrumb){
  .el-breadcrumb__inner{
      color: #999999 !important;
  }
  .bread{
      span{
          color: #0073F5 !important;
      }
  }
}

.info{
  box-sizing: border-box;
  // height: 265px;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;

  padding: 32px 32px 24px 32px;

  margin-bottom: 20px;
}

.shang{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 164px;
  border-bottom: #eee solid 1px;
  .logo{
      width: 48px;
      height: 48px;
      margin-right: 120px;
      img{
        width: 65px;
      }
  }
  .qiyun{
      // width: 120px;
      .jiacu{
        font-weight: bold;
      }
      .date{
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          line-height: 19px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          margin-bottom: 4px;
      }
      .address{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        line-height: 28px;
        font-style: normal;
        text-transform: none;

          overflow:hidden; 
          text-overflow:ellipsis; 
          white-space:nowrap;
      }
  }

  
  .dao{
      width: 100px;
      text-align: center;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      margin: 0 48px;
      img{
          width: 100px;
          height: 7px;
      }
      div{
          height: 12px;
      }
  }
}

.zhong{
  display: flex;

  margin-top: 24px;
  margin-bottom: 12px;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  div{
      margin-right: 48px;
  }
  .kuan{
      width: 130px;
  }
}

.xia{
  display: flex;

  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;

  .kuan{
      width: 130px;
      margin-right: 48px;

      display: flex;
  }

  .kuan:nth-child(2){
      width: 132px;
      margin-right: 42px;
  }
  .cilick{
      cursor: pointer;
      color: #0073F5;
  }
}

.boxType{
  height: 218px;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  box-sizing: border-box;

  margin-bottom: 20px;
  .title{
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .boxNum{
    margin-top: 24px;

    display: flex;
    .box-yi{
      margin-right: 24px;
      .box-tit{
        margin-bottom: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        font-style: normal;
        text-transform: none;
        color: #606260;
        span{
          color: #FE3300;
        }
      }

      .el-input-number{
        width: 242px;
        height: 44px;
      }

      .qian{
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #999999;
        font-style: normal;
        text-transform: none;

        display: flex;
        justify-content: space-between;
        // div{
        //   margin-right: 16px;
        // }
      }
    }
  }
}


.account{
  height: 302px;
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .title{
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .account-conm{
    margin-top: 24px;
    font-size: 14px;
    color: #606260;
  }

  .el-select{
    margin-top: 12px;
  }
  :deep(.el-select){
    width: 400px;
    height: 48px;
    input{
      width: 400px;
      height: 48px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }
    input::placeholder{
      color: #999999;
    }
  }
  .disan{
    margin-top: 20px;
    margin-bottom: 24px;
    width: 400px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .yuan{
      width: 16px;
      height: 16px;
      border: 1px solid #999999;
      border-radius: 50%;
      cursor: pointer;
    }

    .yuan_dui{
      width: 18px;
      height: 18px;
    }
  }

  .xian{
    height: 1px;
    background: #eee;
  }

  .feiyong{
    margin-top: 24px;
    display: flex;
    .el-icon-info{
      margin-right: 4px;
      color: #CCCCCC;
    }
    span{
      color: #333333;
    }
    div:last-child{
      margin-left: 60px;
    }
   
  }
  
}

.fujia{
  background: #FFFFFF;
  border-radius: 12px 12px 12px 12px;
  margin-bottom: 20px;
  padding: 32px;
  box-sizing: border-box;

  .title{
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .el-table{
    margin-top: 20px;
  }

  .dd{
    margin-top: 32px;
  }

  .pdf_tit{
    font-size: 16px;
    color: #333333; 
    margin: 20px 0;
  }

  .pdf{
    width: 400px;
    height: 72px;
    background: #F9F9F9;
    display: flex;
    align-items: center;
    cursor: pointer;
    .pdf-t{
      width: 56px;
      height: 56px;
      background: #E64E3B;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 56px;
      margin-left: 8px;
    }

    .pdf-click{
      font-size: 14px;
      color: #999999;
      margin-left: 12px;
    }
  }
}
.fukuan{
  // width: 1920px;
  height: 118px;
  background: #FFFFFF;

  .fk-content{
    height: 118px;

    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;

    .fk-left{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #606260;
      line-height: 14px;
      font-style: normal;
      text-transform: none;
      .yi{
        .spn{
          font-size: 14px;
          color: #333333;
        }
      }

      .er{
        margin: 8px 0;

        span{
          color: #0073F5;

          cursor: pointer;
        }
      }
    }

    .fk-right{
      .zong{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #FE3300;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .mingxi{
        width: 100px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #0073F5;
        color: #0073F5;
        background: #fff;

        margin-left: 24px;
        margin-right: 16px;
      }

      .tijiao{
        width: 100px;
        height: 40px;
        background: #0073F5;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
      }
    }
  }
}

.modelDetail{
  .detail{
    margin-top: 24px;
    .de-tit{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #999999;
      font-style: normal;
      text-transform: none;
    }

    .de-con{
      display: flex;
      flex-wrap: wrap;
      .conyi{
        width: 213px;
        height: 40px;
        background: #F9F9F9;
        border-radius: 8px 8px 8px 8px;
        margin-right: 17px;
        margin-top: 12px;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        div{
          // line-height: 40px;
          // padding-left: 12px;
          // padding-right: 12px;
          padding: 12px;
          width: 213px;

          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .coner{
        margin-right: 0px;
      }
    }

    .de-coner{
      justify-content: space-between;
      .conyi{
        margin-right: 0px;
      }
    }

    .de-consan{
      .conyi{
        width: 446px;
        height: 140px;

        padding: 12px;

        p{
          line-height: 16px;
          margin: 0;
        }
      }
    }

    .de-consi{
      .conyi{
        width: 290px;
        height: 140px;
      }
    }

    .de-conwu{
      .conyi{
        width: 910px;
        height: 140px;
      }
    }

    .con-up{
      display: flex;
      align-items: center;
      i{
        font-size: 16px;
        color: #00b53c;
        margin-right: 9px;
      }

      .name{
        width: 130px;

        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .el-butnm{
        color: #0073F5;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-transform: none;

        height: 18px;
        padding: 0;
      }
    }
  }
}

.el-drawer{
  .drawer-title{
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span{
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i{
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det{
    padding: 32px 32px 0 32px;
  }

  .tab-tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }
 

  .drawer__footer{
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao{
      width: 100px;
      height: 40px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg{
      width: 100px;
      height: 40px;
      background: #0073F5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}

.CargoInformation {
  // height: 401px;
  background: #FfFFFF;
  border-radius: 12px 12px 12px 12px;
  padding: 32px;
  margin-bottom: 20px;

  .title {
    width: 108px;
    height: 25px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 32px;
  }

  .info-shang {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;

    .word {
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      font-style: normal;
      text-transform: none;
      color: #999999;
      span {
        color: #fe3300;
      }
    }
    :deep(.el-input) {
      input {
        width: 266px;
        height: 44px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 556px;
        height: 160px;
        background: #f9f9f9;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }
    }
  }

  .info-shoufat {
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 362px;
      }
    }
  }
}

.phone-info {
  height: 100%;
  .info-shang {
    flex-wrap: wrap;
    justify-content: start;

    .yi1 {
      margin-right: 24px;
    }
    .yi {
      margin-bottom: 20px;
      margin-right: 24px;

      :deep(.el-input) {
        width: 226px;
        input {
          width: 226px;
          height: 44px;
          background: #f9f9f9;
          border-radius: 8px 8px 8px 8px;
          border: 0;
        }
      }
    }
    .yi2 {
      margin-right: 0px;
    }
    .delete {
      margin-right: 4px;
      font-size: 16px;

      cursor: pointer;

      font-size: 14px;
      color: #fe3300;

      line-height: 44px;
    }

    .ipt_del {
      display: flex;
      width: 266px;
      height: 44px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
    }
  }
  .add {
    width: 120px;
    color: #0073f5;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    font-style: normal;
    text-transform: none;

    cursor: pointer;

    display: flex;
    align-items: center;
  }

  .info_phone {
    .word {
      margin-top: 24px;
    }
    :deep(.el-textarea) {
      .el-textarea__inner {
        width: 1136px;
      }
    }
  }
}


.table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    td{
      padding-left: 12px;
    }
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

    }
}

.datab{
  margin-top: 20px;
  border: solid 1px #eee;

  .xiaotab{
    padding: 0;
  }
}


</style>